import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const outstandingKeyFactory = {
  // ================================
  // OUTSTANDING BILLS LIST
  // ================================
  list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "outstanding",
    "list",
    filters,
  ],
  exportList: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "outstanding",
    "outstandingExport",
    filters,
  ],
  summary: (
    remoteUtilityId: number,
  ): [ModuleType, EntityType, ActionType, number] => [
    "cx",
    "outstanding",
    "summary",
    remoteUtilityId,
  ],
  createPaymentAgreement: (
    remoteUtilityId: number,
    remoteBillId: number,
  ): [ModuleType, EntityType, ActionType, number, number] => [
    "cx",
    "outstanding",
    "create",
    remoteUtilityId,
    remoteBillId,
  ],
  paymentAgreementDetail: (
    remoteUtilityId: number,
    remoteBillId: number,
  ): [ModuleType, EntityType, ActionType, number, number] => [
    "cx",
    "outstanding",
    "paymentAgreementDetail",
    remoteUtilityId,
    remoteBillId,
  ],
  paymentAgreements: (
    remoteUtilityId: number,
    remoteBillId: number,
  ): [ModuleType, EntityType, ActionType, number, number] => [
    "cx",
    "outstanding",
    "paymentAgreements",
    remoteUtilityId,
    remoteBillId,
  ],
  getPaymentAgreementDetail: (
    remoteUtilityId: number,
    remoteBillId: number,
  ): [ModuleType, EntityType, ActionType, number, number] => [
    "cx",
    "outstanding",
    "details",
    remoteUtilityId,
    remoteBillId,
  ],
  paymentAgreementList: (
    filters?: any,
  ): [ModuleType, EntityType, ActionType, any?] => [
    "cx",
    "outstanding",
    "paymentAgreementList",
    filters,
  ],

  accountDetails: (
    accountId: string,
  ): [ModuleType, EntityType, ActionType, string] => [
    "cx",
    "outstanding",
    "details",
    accountId,
  ],
  installmentFrequency: (): [ModuleType, EntityType, string] => [
    "cx",
    "outstanding",
    "installmentFrequency",
  ],
  weekdayOptions: (): [ModuleType, EntityType, string] => [
    "cx",
    "outstanding",
    "weekdayOptions",
  ],
  preferredDayOfMonth: (): [ModuleType, EntityType, string] => [
    "cx",
    "outstanding",
    "preferredDayOfMonth",
  ],
  channelChoices: (
    remoteUtilityId: string,
    context: string,
  ): [ModuleType, EntityType, string, string, string] => [
    "cx",
    "outstanding",
    "channelChoices",
    remoteUtilityId,
    context,
  ],
  noticeTemplates: (
    remoteUtilityId: string,
    channelType: string,
  ): [ModuleType, EntityType, string, string, string] => [
    "cx",
    "outstanding",
    "noticeTemplates",
    remoteUtilityId,
    channelType,
  ],
  bulkCommunicationStep1: (
    filters: any,
  ): [ModuleType, EntityType, ActionType, any] => [
    "cx",
    "outstanding",
    "bulkCommunicationStep1",
    filters,
  ],
  userNames: (filters: any): [ModuleType, EntityType, ActionType, any] => [
    "cx",
    "outstanding",
    "userNames",
    filters,
  ],
  bulkCommunicationAuditSummary: (
    remoteUtilityId: string | number,
  ): [ModuleType, EntityType, ActionType, string | number] => [
    "cx",
    "outstanding",
    "bulkCommunicationAuditSummary",
    remoteUtilityId,
  ],
  bulkCommunicationAuditBatches: (
    filters: any,
  ): [ModuleType, EntityType, ActionType, any] => [
    "cx",
    "outstanding",
    "bulkCommunicationAuditBatches",
    filters,
  ],
  bulkCommunicationResult: (
    id: string | number,
    remoteUtilityId: string | number,
  ): [ModuleType, EntityType, ActionType, string | number, string | number] => [
    "cx",
    "outstanding",
    "bulkCommunicationResult",
    id,
    remoteUtilityId,
  ],
  category: (): [ModuleType, EntityType, ActionType] => [
    "cx",
    "outstanding",
    "category",
  ],
  subCategory: (
    code_list: any[],
  ): [ModuleType, EntityType, ActionType, any[]] => [
    "cx",
    "outstanding",
    "subCategory",
    code_list,
  ],
  premise: (params: any): [ModuleType, EntityType, ActionType, any] => [
    "cx",
    "outstanding",
    "premise",
    params,
  ],
};
